module.exports = __webpack_public_path__ + "static/img/pdf-icon.8b0cf36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf-icon.png
// module id = hIcg
// module chunks = 1